import maintenance from "@/assets/game/maintenance.png";
import online from "@/assets/game/online.png";
export default {
  name: "gameMaintai",
  props: {
    dataOpt: {
      type: [Object],
      default: () => null,
    },
  },
  data() {
    return {
      maintenance,
      online,
      gameGroupMamintaiList: [],
      gameGroupSoonList: [],
      gameGroupBtnHideList: [],
    };
  },
  created() {
    // console.log(this.dataOpt, "---------");
  },
  mounted() {
    this.$Bus.$on("gameGroupMamintai", (data) => {
      if (data.status === 3) {
        this.gameGroupMamintaiList.push(String(data?.gameGroupSid));
      }
      if (data.status === 4) {
        this.gameGroupSoonList.push(String(data?.gameGroupSid));
      }
      this.gameGroupBtnHideList.push(String(data?.gameGroupSid));
      this.$emit("btnHide", this.gameGroupBtnHideList);
    });
  },
  beforeDestroy() {
    this.$Bus.$off("gameGroupMamintai");
  },
  computed: {
    type() {
      if (
        this.dataOpt.rowStatus === "GAME_STATUS_MAINTENANCE" ||
        this.gameGroupMamintaiList.includes(this.dataOpt.gameGroupSid)
      ) {
        // GAME_STATUS_MAINTENANCE
        // 维护中
        return 1;
      }
      if (
        this.dataOpt.rowStatus === "GAME_STATUS_SOON_ONLINE" ||
        this.gameGroupSoonList.includes(this.dataOpt.gameGroupSid)
      ) {
        // GAME_STATUS_ONLINE
        // 即将上线
        return 2;
      }
    },
  },
  methods: {},
};
